var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeout-countdown"},[_vm._v(" "+_vm._s(_vm.counter)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }